import $ from "jquery";


function tab_height(){
    $('.tabanimationcontainer').animate({
        height: ($('.tabscontainer').height() + 100) + 'px'
    }, 100);
}

function active_tab(tabid, obj, parent){
    var tabAnimationContainer = parent.find('.tabanimationcontainer');
    var tabContainer = parent.find('.tabcontainer');
    var activeTab = parent.find('.' + tabid);
    if (obj.hasClass('activetab')) {

    } else {
        $('.activetab').removeClass('activetab');
        obj.addClass('activetab');

        tabAnimationContainer.animate({ left: '-100px', opacity: "0" }, 200, function() {
            tabAnimationContainer.css("left", "100px");
            tabContainer.hide();
            activeTab.show();
            tabAnimationContainer.animate({
                left: '0px',
                opacity: '1',
                height: (activeTab.height() + 100) + 'px'
            }, 300);
        });
    }
}

window.addEventListener('DOMContentLoaded', (event) => {
    tab_height();
});

$(window).resize(function() {
    tab_height();
});


$('.taboption').click(function(event) {
    var tabid = $(event.target).attr('id');
    var obj = $(event.target);
    var parent = obj.closest(".tab-con");
    active_tab(tabid, obj, parent);
});

